import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ActionButton from 'components/ActionButton';
import Button from 'components/DesignSystem/Button';
import Snackbar from 'components/DesignSystem/Snackbar';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import {
  useDeletePastSimulationMutation,
  useListPastSimulationsQuery,
} from 'services/api/products/flux';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import {
  togglePastSimulation,
  selectFluxAutomaticControlPanelPastSimulations,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

import NewForm from './NewForm';

import './index.scss';

export default function PastSimulations() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const selectedIds = useSelector(selectFluxAutomaticControlPanelPastSimulations);
  const { data: pastSimulations } = useListPastSimulationsQuery();
  const [
    deletePastSimulation,
    { isLoading: isDeleting, error: deleteError },
  ] = useDeletePastSimulationMutation();

  useHandleRequestErrors(deleteError as ResponseError);

  const simulations = pastSimulations ?? [];

  return (
    <>
      {simulations.length === 0 && (
        <Snackbar className="mt-2">Nenhuma simulação antiga cadastrada.</Snackbar>
      )}

      {simulations.map((simulation) => (
        <div className="flux-automatic-past-simulation" key={simulation.id}>
          <div className="flux-automatic-past-simulation-option">
            <OptionRow
              label={simulation.name}
              selected={selectedIds.includes(simulation.id)}
              selectionType="multiple"
              onSelect={() => dispatch(togglePastSimulation(simulation.id))}
            />
          </div>
          <ActionButton
            loading={isDeleting}
            onClick={() => deletePastSimulation(simulation.id)}
            icon="trash"
            type="tertiary"
            small
          />
        </div>
      ))}

      {!showForm && (
        <Button
          icon="add"
          type="tertiary"
          onClick={() => setShowForm(true)}
          className="w-100 mt-2"
        >
          Nova simulação antiga
        </Button>
      )}

      {showForm && <NewForm close={() => setShowForm(false)} />}
    </>
  );
}
